import React from 'react';
import TouchableOpacity from './TouchableOpacity';

import { useAppSelector } from '../app/hooks';
import getThemeLookup from '../selectors/getThemeLookup';
import { TEXT_PROPERTIES } from '../utils/theme';
import combineStyles from '../utils/combineStyles';
import Text from '../components/Text';

/**
 * # Section Button
 *
 * This is a button that is used inside of <SectionContainer/>
 *
 * You can see this being used for the "Enter new delivery address" button
 * which is located in the Delivery Address section of the delivery screen
 *
 * @param themeKey The theming key for the text,
 * @param onPress,
 * @param label,
 */
const SectionButton = ({
  themeKey,
  onPress,
  label,
}: {
  themeKey: string;
  onPress: () => void;
  label?: string;
}) => {
  const p = useAppSelector(getThemeLookup);

  return (
    <div style={styles.sectionButtonWrapper}>
      <TouchableOpacity onClick={onPress} style={styles.sectionButton}>
        <Text
          style={combineStyles(
            p('defaultText', TEXT_PROPERTIES),
            p('defaultPrimaryTransparentButton', TEXT_PROPERTIES),
            p(themeKey, TEXT_PROPERTIES),
          )}
        >
          {label}
        </Text>
      </TouchableOpacity>
    </div>
  );
};

export default SectionButton;

const styles: Styles = {
  sectionButton: {
    padding: '15px 20px',
    flex: 1,
    width: '100%',
  },
  sectionButtonWrapper: {
    borderRadius: 10,
    overflow: 'hidden',
  },
};
